<div class="p-3 border rounded-3 bg-light shadow">
  <h6 class="mb-3">
    <i class="fa-solid fa-check-double"></i>
    Действия
  </h6>
  @if (adDetails.actionPermissions.canEdit) {
    <a class="mb-3 w-100 btn btn-nz-primary"
       [class.disabled]="loading"
       [routerLink]="[appRoutes.root, appRoutes.adUpdate, adId]">
      <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
      Редактиране на обявата
    </a>
  }
  @if (adDetails.actionPermissions.canRenew) {
    <button
      class="mb-3 w-100 btn btn-nz-primary"
      [disabled]="loading"
      (click)="onOpenAdRenewalIndividualModal('after-expired')">
      <i class="fa-solid fa-arrows-rotate" aria-hidden="true"></i>
      Обновяване на обявата
    </button>
  }
  @if (adDetails.actionPermissions.canCopyAsNew) {
    <button
      class="mb-3 w-100 btn btn-nz-primary"
      [disabled]="loading"
      (click)="onOpenAdRenewalIndividualModal('after-sold')">
      <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
      Копиране като нова обява
    </button>
  }
  @if (adDetails.actionPermissions.canCreateSimilar) {
    <a class="mb-3 w-100 btn btn-nz-primary"
       [class.disabled]="loading"
       [routerLink]="[appRoutes.root, appRoutes.adCrateSimilar, adId]">
      <i class="fa-solid fa-copy"></i>
      Създаване на подобна обява
    </a>
  }
  @if (adDetails.actionPermissions.canDelete || adDetails.actionPermissions.canStop) {
    <div class="dropdown mb-3">
      <a class="w-100 btn btn-light border text-muted dropdown-toggle"
         type="button"
         data-bs-toggle="dropdown"
         aria-expanded="false">
        Още действия
      </a>
      <ul class="dropdown-menu dropdown-menu-end rounded-end-0 shadow">
        @if (adDetails.actionPermissions.canStop) {
          <li>
            <button class="dropdown-item"
                    [disabled]="loading"
                    (click)="showStopAdWarning()">
              <i class="dropdown-item-icon text-warning fa-solid fa-ban" aria-hidden="true"></i>
              Спиране на обявата
            </button>
          </li>
        }
        @if (adDetails.actionPermissions.canDelete && adDetails.actionPermissions.canStop) {
          <li>
            <hr class="dropdown-divider">
          </li>
        }
        @if (adDetails.actionPermissions.canDelete) {
          <li>
            <button class="dropdown-item"
                    [disabled]="loading"
                    (click)="showDeleteAdWarning()">
              <i class="dropdown-item-icon text-danger fa-solid fa-trash-can" aria-hidden="true"></i>
              Изтриване на обявата
            </button>
          </li>
        }
      </ul>
    </div>
  }
  <hr class="mt-0">
  <button class="p-0 btn btn-link text-decoration-none"
          [disabled]="adDetails.renewalAfterExpirationCount <= 0"
          (click)="onOpenRenewalHistoryModal()">
    Обновявания: {{ adDetails.renewalAfterExpirationCount }}
  </button>
</div>
